'use strict'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { TrainerCard } from './subComponents/TrainerCard'
import { MeetingDetails } from './subComponents/MeetingDetails'
import { FlmForm } from './form/flm-form'
import { FlmThankYouView } from './flm-thankyou-view'
import { GoogleRecaptchaProviderWrapper } from '../googleRecaptchaV3'
import { __ } from '@wordpress/i18n'

const FreeLiveMeetingPage = (props) => {
  const {data} = props;
  const liveMeetings = data.trainings;
  const gaID = data.ga_id
  const acf_options = data.acf_options;
  const [activeRecord, setActiveRecord] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)

  React.useEffect(() => {
    setTimeout(() => {

      if (activeRecord) {
        if (document.querySelector('#form_' + activeRecord)) {
          document.querySelector('#form_' + activeRecord).scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'start'
          })
        }

      }
    }, 100)
  }, [activeRecord])

  React.useEffect(() => {
    if (showThankYou) {
      setActiveRecord(false)
    }
  }, [showThankYou])

  if (showThankYou) {
    return (
      <FlmThankYouView liveMeetings={liveMeetings} setShowThankYou={setShowThankYou}/>
    )
  }
  return (
    <Container className={'flm-page'}>
      <div className={'flm-header'}>
        <h1>{__('Poznaj bezpłatne wydarzenia', 'strefamanagera')}</h1>
      </div>
      {liveMeetings.length > 0 ? (
        <div className={'flm-list'}>
          {liveMeetings.map((data) => (
            <LiveMeetingRecord key={'key_'+data.meeting.id} data={data} setShowThankYou={setShowThankYou}
                               setActiveRecord={setActiveRecord}
                               acf_options={acf_options}
                               activeRecord={activeRecord} gaID={gaID}/>
          ))}
        </div>
      ) : (
        <div className={'flm-noevents'}>
          <p>
            {__('W tym momencie nie mamy zaplanowanych bezpłatnych wydarzeń.', 'strefamanagera')}<br/>
            {__('Śledź nasz profil na Facebooku, aby być na bieżąco z naszymi propozycjami.', 'strefamanagera')}<br/>
            {__('Zachęcamy do zapoznania się z aktualną ofertą pozostałych wydarzeń.', 'strefamanagera')}
          </p>
          <div>
            <div className={'buttons'}>

              <a href={'/oferta'}>
                <div className={'pinkBtn'}>
                  <div className="btn btn-lg">
                    {__('Zobacz ofertę', 'strefamanagera')}
                  </div>
                </div>
              </a>

              <a href={'/'}>
                <div className={'primaryBtn'}>
                  <div className="btn btn-lg">
                   {__('Przejdź do strony głównej', 'strefamanagera')}
                  </div>
                </div>
              </a>
            </div>
          </div>

        </div>
      )}
    </Container>
  )
}

const LiveMeetingRecord = (props) => {
  const { data,gaID, setActiveRecord, setShowThankYou, activeRecord,acf_options } = props
  React.useEffect(()=>{
    if(window.location.hash) {
      setTimeout(() => {
        let anchor = document.querySelector(window.location.hash);
        if (anchor) {
          anchor.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        }
      }, 500)
    }
  },[])

  return (
    <Row  className={'flm-eventRow'} id={'event_' + data.meeting.id}>
      <Col lg={12} md={12} sm={12}>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <TrainerCard acf_options={acf_options} trainer={data.trainer}/>
          </Col>
          <Col lg={8} md={6} sm={12}>
            <MeetingDetails acf_options={acf_options} meeting={data.meeting}/>

            <div className="assign-button">
              <div onClick={() => {
                setActiveRecord(data.meeting.id)
              }} className="btn btn-lg">
                {__('Zapisz się', 'strefamanagera')}
              </div>
            </div>


          </Col>
        </Row>

      </Col>
      {activeRecord === data.meeting.id ? (
        <Col lg={12} md={12} sm={12}>
          <FlmForm acf_options={acf_options} setShowThankYou={setShowThankYou} activeRecord={activeRecord} setActiveRecord={setActiveRecord}
                   data={data} gaID={gaID}/>
        </Col>
      ) : null}
    </Row>
  )
}

if (document.querySelector('#free-livemeeting-page')) {
  ReactDOM.render(<GoogleRecaptchaProviderWrapper><FreeLiveMeetingPage data={window.flm_page}/></GoogleRecaptchaProviderWrapper>, document.querySelector('#free-livemeeting-page'))
}
